import { Box } from "@mui/material"
import EuropcarCompanySelector from "Pages/BusinessLogistics/Analytics/Page/Filters/Company"
import React from "react"
import EuropcarUserSelector from "Pages/BusinessLogistics/Analytics/Page/Filters/Users"
import EuropcarSiteSelector from "Pages/BusinessLogistics/Analytics/Page/Filters/Sites"
import EuropcarDateRangeFilter from "Pages/BusinessLogistics/Analytics/Page/Filters/DateRange"
import { AppFilterBar } from "@components"

// The page filters in one white strip, as Search Analytics
export default function EuropcarAnalyticsFilters() {

	return <AppFilterBar sx={{ mb: 0 }}>
		<Box sx={{ width: 290 }}>
			<EuropcarDateRangeFilter/>
		</Box>
		<Box sx={{ width: 240 }}>
			<EuropcarCompanySelector/>
		</Box>
		<Box sx={{ width: 240 }}>
			<EuropcarUserSelector/>
		</Box>
		<Box sx={{ width: 240 }}>
			<EuropcarSiteSelector/>
		</Box>
	</AppFilterBar>
}
